import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgChat({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.874 19.219A10.135 10.135 0 0116.203 17H19a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v11a1 1 0 001 1h3.997v2.92l.877-.701zM5 19a3 3 0 01-3-3V5a3 3 0 013-3h14a3 3 0 013 3v11a3 3 0 01-3 3h-2.797a8.135 8.135 0 00-5.08 1.781l-1.69 1.35a1.5 1.5 0 01-2.436-1.17V19H5zm1.426-6.68a1 1 0 111.147-1.64 7.72 7.72 0 008.854 0 1 1 0 111.146 1.64 9.719 9.719 0 01-11.147 0z"
        fill={color}
      />
    </svg>
  )
}

export default SvgChat
